import { Stack, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { useDictionary, useIsDesktop } from 'Hooks';
import { FileTypeError, IFile } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface InformationProps {
  file: IFile;
  isChecked: boolean;
  onCheckboxChange: (fileId: number, checked: boolean) => void;
}

export const Information = ({
  file,
  isChecked,
  onCheckboxChange,
}: InformationProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.DOCUMENTS_HANDLE);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onCheckboxChange(file.id, event.target.checked);
  };

  return (
    <Stack pr={'12px'} maxWidth={isDesktop ? 'fit-content' : '400px'}>
      {file.fileCategoryName && (
        <Typography
          fontWeight='bold'
          fontSize={isDesktop ? '18px !important' : '16px !important'}
        >
          {file.fileCategoryName}
        </Typography>
      )}
      <Typography mb={'6px'} fontSize={'14px !important'}>
        {file.userGivenName}
      </Typography>
      {file.displayErrorText && (
        <Stack
          direction='row'
          gap='6px'
          sx={{
            backgroundColor: isChecked ? '#E0E0E0' : '#f6e7ea',
            borderRadius: '8px',
            border: isChecked ? 'none' : '2px solid #A30F28',
            padding: isDesktop ? '10px 16px' : '8px',
            mb: '6px',
            maxWidth: '470px',
          }}
        >
          <Typography
            color={'#39556B !important'}
            fontSize={isDesktop ? '16px !important' : '12px !important'}
            variant='h4'
          >
            {file.displayErrorText}
            {file.fileCategoryRelationId ===
            FileTypeError.ErrorIdentificationDetails ? (
              <span> {dictionary.errorFileId}</span>
            ) : file.fileCategoryRelationId ===
              FileTypeError.ErrorMismatchType ? (
              <span>{`${dictionary.needToAttach} ${file.fileCategoryName}`}</span>
            ) : null}
          </Typography>
        </Stack>
      )}
      {file.displayErrorText && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={handleCheckboxChange}
              color='primary'
            />
          }
          label={
            <Typography
              variant='subtitle1'
              fontSize={isDesktop ? undefined : '12px'}
            >
              {dictionary.iChecked}
            </Typography>
          }
        />
      )}
    </Stack>
  );
};
